/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Enter a negative numerator or denominator and the sign is carried through and normalised onto the numerator in the result.`)
};

const es_fr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Introduce un numerador o denominador negativo y el signo se traslada y se normaliza en el numerador del resultado.`)
};

const de_fr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Gib einen negativen Zähler oder Nenner ein — das Vorzeichen wird übernommen und im Ergebnis auf den Zähler normalisiert.`)
};

const nl_fr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Vul een negatieve teller of noemer in en het teken wordt doorgevoerd en in het resultaat op de teller genormaliseerd.`)
};

const fr_fr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Saisissez un numérateur ou dénominateur négatif et le signe est reporté et normalisé sur le numérateur dans le résultat.`)
};

const it_fr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Inserisci un numeratore o denominatore negativo e il segno viene mantenuto e normalizzato sul numeratore nel risultato.`)
};

const pt_br2_fr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Informe um numerador ou denominador negativo e o sinal é mantido e normalizado no numerador do resultado.`)
};

const pt_fr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Introduza um numerador ou denominador negativo e o sinal é transportado e normalizado para o numerador no resultado.`)
};

const ja_fr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。負の分子や分母を入力すると、符号はそのまま反映され、結果では分子に正規化されます。`)
};

const zh_fr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。输入负的分子或分母，符号会被保留并在结果中统一归到分子上。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_faq_a4", locale)
	if (locale === "en") return en_fr_faq_a4(inputs)
	if (locale === "es") return es_fr_faq_a4(inputs)
	if (locale === "de") return de_fr_faq_a4(inputs)
	if (locale === "nl") return nl_fr_faq_a4(inputs)
	if (locale === "fr") return fr_fr_faq_a4(inputs)
	if (locale === "it") return it_fr_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_fr_faq_a4(inputs)
	if (locale === "pt") return pt_fr_faq_a4(inputs)
	if (locale === "ja") return ja_fr_faq_a4(inputs)
	return zh_fr_faq_a4(inputs)
};